module.exports = __webpack_public_path__ + "img/21_92.30cc2e4d.png";